module.exports = __webpack_public_path__ + "img/ic_fresh_new_logo.c1f14755.png";